import React from 'react'

import { Icon, Discount, Quality } from '@cgtrader/triangle-ui/dist/src/ssr-index'

export const pricingCheckboxFiltersConfig = [{
  label: '',
  filters: [
    {
      value: 'on_sale',
      label: (
        <span className="filter-wrapper__option--with-icon">
          <Icon notSpaced svgComponent={Discount} color="primary" size="small" />
          <span>On Sale</span>
        </span>
      ),
    },
    {
      value: 'with_subscription',
      label: (
        <span className="filter-wrapper__option--with-icon">
          <Icon notSpaced svgComponent={Quality} color="primary" size="small" />
          <span>Subscription items</span>
        </span>
      ),
    },
  ],
}]
